export async function api(path, options = {}) {
  const response = await fetch(path, {
    credentials: 'same-origin',
    signal: options.signal || AbortSignal.timeout(45_000),
    ...options,
    headers: {
      ...(options.body instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
      ...(options.headers || {}),
    },
  });

  const payload = await response.json().catch(() => ({ error: 'invalid_json_response' }));
  if (!response.ok) {
    const error = new Error(payload.error || `request_failed_${response.status}`);
    error.status = response.status;
    error.payload = payload;
    throw error;
  }
  return payload;
}

export function downloadJson(filename, value) {
  const blob = new Blob([JSON.stringify(value, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}

